<form [formGroup]="searchForm">
    @if (_internalConfiguration) {
        <mat-form-field class="form-item search-term without-error">
            <fa-icon matPrefix class="mat-accent search-icon" [icon]="searchIcon"></fa-icon>
            <input matInput tabindex="1" placeholder="Terme à rechercher" formControlName="searchControl" autocomplete="off" />
        </mat-form-field>
        <div class="buttons">
            <button mat-stroked-button class="primary-button button-launch-search" tabindex="4" (click)="onSearch()">Lancer la recherche</button>
            <button mat-fab class="primary-button button-filter" aria-label="Réinitialiser" matTooltip="Réinitialiser" matTooltipPosition="below" (click)="onUndo()">
                <fa-icon [icon]="resetFilterIcon"></fa-icon>
            </button>
            <button mat-fab class="primary-button button-filter" aria-label="Filtrer..." matTooltip="Filtrer..." matTooltipPosition="below" [matMenuTriggerFor]="filterMenu">
                <fa-icon [icon]="filterIcon"></fa-icon>
            </button>
            <button
                mat-fab
                class="primary-button button-manage-filter button-filter"
                aria-label="Gestion des filtres..."
                matTooltip="Gestion des filtres..."
                matTooltipPosition="below"
                [matMenuTriggerFor]="filterManageMenu">
                <fa-icon [icon]="filterIcon" class="filter-icon"></fa-icon>
                <fa-icon [icon]="saveIcon" class="save-icon"></fa-icon>
            </button>
        </div>
        <div class="auto-filter-warning">
            @if (autoFiltersPresence) {
                <fa-icon
                    [icon]="warningIcon"
                    matTooltip="Attention : Les critères de recherche / filtres de votre précédant affichage de la vue ont été appliqués à cette liste! Cliquez sur le bouton 'Réinitialiser' pour les supprimer."
                    matTooltipPosition="below"></fa-icon>
            }
        </div>
        <mat-menu #filterMenu="matMenu" class="folders-filter-menu">
            <div class="filter-menu">
                @if (filteredAttributesList.length > 0) {
                    <div>
                        <p class="menu-title">Retirer un attribut du filtre</p>
                        @for (attributefiltered of filteredAttributesList; track attributefiltered.id) {
                            <div class="menu-item">
                                <mat-checkbox class="primary-button" checked="true" (change)="onRemoveAttributeFromFilter(attributefiltered)">
                                    {{ attributefiltered.header }}
                                </mat-checkbox>
                            </div>
                        }
                    </div>
                }
                @if (availableAttributesList.length > 0) {
                    <div>
                        <p class="menu-title">Ajouter un attribut à filtrer</p>
                        @for (attribute of availableAttributesList; track attribute.id) {
                            <div class="menu-item">
                                <mat-checkbox class="primary-button" (change)="onAddAttributeToFilter(attribute)">{{ attribute.header }}</mat-checkbox>
                            </div>
                        }
                    </div>
                }
            </div>
        </mat-menu>
        <mat-menu #filterManageMenu="matMenu" class="folders-filter-manage-menu avmup-menu">
            <div class="filter-manage-menu">
                <p class="menu-title">Gestion des filtres</p>
                @if (managePredefinedFiltersRight) {
                    @if (currentPredefinedFilter.id === null) {
                        <a class="avmup-menu-item mat-mdc-menu-item" (click)="onSavePredefinedFilter()">
                            <fa-icon [icon]="saveIcon"></fa-icon>
                            Enregistrer
                        </a>
                    } @else {
                        <a class="avmup-menu-item mat-mdc-menu-item" (click)="onSavePredefinedFilterUnder()">
                            <fa-icon [icon]="saveIcon"></fa-icon>
                            Enregistrer sous...
                        </a>
                        @if (currentPredefinedFilter.ownerId === connectedUserId) {
                            <a class="avmup-menu-item mat-mdc-menu-item" (click)="onEditPredefinedFilter()">
                                <fa-icon [icon]="editIcon"></fa-icon>
                                Modifier...
                            </a>
                        }
                    }
                }

                @if (_internalConfiguration.predefinedFilters.length > 0) {
                    <div>
                        <p class="menu-title">Filtres prédéfinis</p>
                        @for (predefinedFilter of _internalConfiguration.predefinedFilters; track predefinedFilter.id) {
                            <div class="menu-item predefined-filter-container" [ngClass]="{ 'predefined-filter-selected': predefinedFilter.id === currentPredefinedFilter.id }">
                                <a class="predefined-filter-item" (click)="onApplyPredefinedFilter(predefinedFilter)">
                                    <fa-icon [icon]="filterIcon"></fa-icon>
                                    {{ predefinedFilter.name }}
                                </a>
                                @if (
                                    managePredefinedFiltersRight &&
                                    (predefinedFilter.shared === false || (predefinedFilter.shared === true && predefinedFilter.ownerId === connectedUserId))
                                ) {
                                    <a class="predefined-filter-delete-icon" (click)="onDeletePredefinedFilter(predefinedFilter)">
                                        <fa-icon [icon]="deleteIcon"></fa-icon>
                                    </a>
                                }
                                @if (predefinedFilter.shared === true && predefinedFilter.ownerId !== connectedUserId) {
                                    <span class="predefined-filter-shared-icon">
                                        <fa-icon [icon]="shareIcon"></fa-icon>
                                    </span>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </mat-menu>
        @for (filter of filteredAttributesList; track filter.id) {
            <mat-chip-listbox>
                <button #filterChip class="attribute-filter-button" [matMenuTriggerFor]="chipMenu">
                    <mat-chip-option
                        (removed)="onRemoveAttributeFromFilter(filter)"
                        [matTooltip]="
                            !isColorInput(filter)
                                ? isDateInput(filter)
                                    ? (currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDate)
                                    : isDateAndTimeInput(filter)
                                      ? (currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDateAndTime)
                                      : (filter | avmAttributeFilterSubstring: currentFilterHandler.filtersForm.get(filter.propertyCode)?.value : 150)
                                : (currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmColor)
                        ">
                        @if (isColorInput(filter)) {
                            <span>{{ filter.header }}: {{ currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmColor }}</span>
                        } @else if (isDateInput(filter)) {
                            <span>{{ filter.header }}: {{ currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDate }}</span>
                        } @else if (isDateAndTimeInput(filter)) {
                            <span>{{ filter.header }}: {{ currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDateAndTime }}</span>
                        } @else {
                            <span>{{ filter.header }}: {{ filter | avmAttributeFilterSubstring: currentFilterHandler.filtersForm.get(filter.propertyCode)?.value : 30 }}</span>
                        }
                        <mat-icon>expand_more</mat-icon>
                        <mat-menu style="visibility: hidden" class="attribute-filter-menu" #chipMenu="matMenu">
                            <form [formGroup]="currentFilterHandler.filtersForm" novalidate>
                                <div (click)="$event.stopPropagation()">
                                    @if (!isListInput(filter) && !isColorInput(filter)) {
                                        <mat-form-field
                                            class="mat-form-field-filter without-error"
                                            [ngClass]="{
                                                'active-filter': !!currentFilterHandler.filterValues[filter.propertyCode],
                                                'mat-form-field-date-filter': isDateInput(filter),
                                            }">
                                            <div class="mat-form-field-date-filter-container">
                                                @if (isStandardInput(filter)) {
                                                    <input
                                                        matInput
                                                        [formControlName]="filter.propertyCode"
                                                        [placeholder]="filter.header"
                                                        class="text-filter-input"
                                                        autocomplete="off"
                                                        (click)="$event.stopPropagation()" />
                                                } @else if (isDateInput(filter)) {
                                                    <input
                                                        matInput
                                                        tabindex="3"
                                                        [matDatepicker]="i"
                                                        [formControlName]="filter.propertyCode"
                                                        [placeholder]="filter.header"
                                                        class="date-filter-input"
                                                        autocomplete="off" />
                                                    @if (isDateInput(filter)) {
                                                        <mat-datepicker-toggle matSuffix [for]="i" [hidden]="!isDateInput(filter)"></mat-datepicker-toggle>
                                                    }
                                                    <mat-datepicker #i [hidden]="!isDateInput(filter)"></mat-datepicker>
                                                } @else if (isDateAndTimeInput(filter)) {
                                                    <input
                                                        matInput
                                                        tabindex="3"
                                                        [ngxMatDatetimePicker]="j"
                                                        [formControlName]="filter.propertyCode"
                                                        [placeholder]="filter.header"
                                                        class="date-filter-input"
                                                        autocomplete="off" />
                                                    @if (isDateAndTimeInput(filter)) {
                                                        <mat-datepicker-toggle matSuffix [for]="j" [hidden]="!isDateAndTimeInput(filter)"></mat-datepicker-toggle>
                                                    }
                                                    <ngx-mat-datetime-picker #j [hidden]="!isDateAndTimeInput(filter)"></ngx-mat-datetime-picker>
                                                } @else if (isAutocompletionByApiInput(filter)) {
                                                    <input
                                                        matInput
                                                        [formControlName]="filter.propertyCode"
                                                        [placeholder]="filter.header"
                                                        class="text-filter-input"
                                                        autocomplete="off"
                                                        (click)="$event.stopPropagation()" />
                                                }
                                            </div>
                                        </mat-form-field>
                                    }
                                    @if (isListInput(filter) && filter.propertyCode !== BOX_ID) {
                                        <mat-selection-list class="primary-button list-selection" [formControlName]="filter.propertyCode">
                                            @for (item of filter.values; track item.value) {
                                                <mat-list-option [value]="item.value" checkboxPosition="before">{{ item.text }}</mat-list-option>
                                            }
                                        </mat-selection-list>
                                    }
                                    @if (isColorInput(filter)) {
                                        <mat-selection-list class="primary-button list-selection list-filter-input color-mat-select" [formControlName]="filter.propertyCode">
                                            <mat-list-option [value]="Colors.None" checkboxPosition="before">Aucune</mat-list-option>
                                            <mat-list-option [value]="Colors.Green" checkboxPosition="before">
                                                <div class="color-indicator mat-option-green-color"></div>
                                            </mat-list-option>
                                            <mat-list-option [value]="Colors.Orange" checkboxPosition="before">
                                                <div class="color-indicator mat-option-orange-color"></div>
                                            </mat-list-option>
                                            <mat-list-option [value]="Colors.Red" checkboxPosition="before">
                                                <div class="color-indicator mat-option-red-color"></div>
                                            </mat-list-option>
                                            <mat-list-option [value]="Colors.Grey" checkboxPosition="before">
                                                <div class="color-indicator mat-option-grey-color"></div>
                                            </mat-list-option>
                                            <mat-list-option [value]="Colors.LightBlue" checkboxPosition="before">
                                                <div class="color-indicator mat-option-light-blue-color"></div>
                                            </mat-list-option>
                                            <mat-list-option [value]="Colors.DarkBlue" checkboxPosition="before">
                                                <div class="color-indicator mat-option-dark-blue-color"></div>
                                            </mat-list-option>
                                        </mat-selection-list>
                                    }
                                </div>
                            </form>
                        </mat-menu>
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-option>
                </button>
            </mat-chip-listbox>
        }
    }
</form>
